import React from "react";
import GenericModal from "web/react/components/generic-modal/generic-modal";
import Button from "web/react/components/button/button";
import { gettext } from "web/script/modules/django-i18n";
import styles from "./cookie-read-more-modal.css";
export default function CookieReadMoreModal(_ref) {
  var isOpen = _ref.isOpen,
      onModalClose = _ref.onModalClose,
      title = _ref.title,
      content = _ref.content;
  return React.createElement(GenericModal, {
    isOpen: isOpen,
    onClose: onModalClose,
    className: styles.modal,
    noScroll: false
  }, React.createElement("div", {
    className: styles.readMoreWrapper
  }, React.createElement("div", {
    className: styles.readMoreTitle
  }, title), React.createElement("div", {
    className: styles.contentWrapper
  }, React.createElement("div", {
    className: styles.readMoreContent,
    dangerouslySetInnerHTML: {
      __html: content
    }
  })), React.createElement(Button, {
    className: "",
    fullHeight: false,
    fullWidth: true,
    openInNewTab: false,
    disabled: false,
    onClick: onModalClose,
    styleType: "tertiary"
  }, gettext("general.done"))));
}